import { Injectable } from "@angular/core";
import { BaseService } from "../../@core/services/base.service";
import { environment } from "../../../environments/environment.dev";
import { HttpClient } from "@angular/common/http";
import { IMilestone, MILESTONE_TYPE } from "../../@core/models/model";

@Injectable({ providedIn: 'root' })
export class MileStoneService extends BaseService {
    private milestoneUrl = environment.apiUrl + '/milestone';

    constructor(protected override http: HttpClient) {
        super(http);
    }

    getMilestones(type: MILESTONE_TYPE, projectId?: string, documentId?: string, documentType?: string) {
        return this.post<IMilestone[]>(this.milestoneUrl + '/all', { type, project: projectId ? projectId : undefined, document: documentId ? documentId : undefined, documentType: documentType ? documentType : undefined });
    }

    getReportMilestones(analysisId?: string) {
        return this.post<IMilestone[]>(this.milestoneUrl + '/report', { analysis: analysisId ? analysisId : undefined });
    }

    addMilestone(name: string, type: MILESTONE_TYPE, documentType?: string) {
        return this.post<IMilestone>(this.milestoneUrl + '/add', { name, type, documentType });
    }

    updateMilestone(name: string, id: string, type: MILESTONE_TYPE, documentType?: string) {
        return this.put<IMilestone>(this.milestoneUrl + '/update', { name, id, type, documentType });
    }

    updateMilestones(milestones: Partial<IMilestone>[], deletedMilestoneIds: string[] = [], type: MILESTONE_TYPE, projectId?: string, contractId?: string) {
        return this.post<IMilestone[]>(this.milestoneUrl + '/update-milestones', {
            milestones,
            deletedMilestoneIds,
            type,
            projectId: projectId ? projectId : undefined,
            contractId: contractId ? contractId : undefined
        });
    }

    deleteMilestone(milestoneId: string) {
        return this.delete(this.milestoneUrl + '/' + milestoneId);
    }
}